import React from 'react'

const StatusPanel = ({
  icon,
  title,
  description,
  className = '',
  descriptionClassName = '',
  children,
}: {
  icon: JSX.Element
  title: string
  description: string | JSX.Element | JSX.Element[]
  className?: string
  descriptionClassName?: string
  children?: JSX.Element
}) => {
  return (
    <div className={`flex flex-col items-center ${className}`}>
      <div className="text-50 text-primary">{icon}</div>
      <p className="font-bold text-center uppercase mt-30 text-14 text-grey-750">{title}</p>
      <p className={`mt-15 text-center text-18 text-grey-800 max-w-[275px] ${descriptionClassName}`}>
        {description}
      </p>
      {children && <div className="mt-30">{children}</div>}
    </div>
  )
}

export default StatusPanel
